import { render, staticRenderFns } from "./SectionTransport.vue?vue&type=template&id=39b74ed9&"
import script from "./SectionTransport.vue?vue&type=script&lang=js&"
export * from "./SectionTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports